(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feevra-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fvh-sticky')) {
    class FvhSticky extends HTMLElement {
      constructor() { super(); }
      connectedCallback() {
        this.alwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.lastY = window.pageYOffset || 0;
        this.tickQueued = false;
        this.bound = this.onScroll.bind(this);
        // Initial state
        if (this.alwaysSticky) this.classList.add('fvh-sticky-on');
        window.addEventListener('scroll', this.bound, { passive: true });

        // Hvor meget ligger der OVER header-sektionen inde i gruppen?
        // Præcis så meget skal gruppen have i negativ top, så annonce-
        // bjælkerne ruller ud af syne og headeren lander på 0.
        this.gruppe  = document.getElementById('header-group');
        this.sektion = this.closest('.shopify-section');
        this.maalTop = () => {
          if (!this.gruppe || !this.sektion) return;
          // Måles med getBoundingClientRect, ikke offsetTop. offsetTop regnes
          // fra nærmeste POSITIONEREDE forfader — og i det øjeblik gruppen selv
          // bliver sticky, bliver den forfaderen. Så skiftede referencepunktet
          // under os, og værdien faldt til 0, hvorefter annoncebjælken blev
          // hængende i toppen sammen med headeren. To rects trukket fra
          // hinanden giver den samme indbyrdes afstand uanset scrollposition.
          const over = Math.round(
            this.sektion.getBoundingClientRect().top - this.gruppe.getBoundingClientRect().top
          );
          this.gruppe.style.setProperty('--fvh-group-top', (-Math.max(0, over)) + 'px');
        };
        this.maalTop();

        /* ------------------------------------------------------------------
           Overlay-tilstand: headeren svæver over heroen indtil man har
           rullet forbi den.

           Skiftepunktet måles på BJÆLKENS underkant mod HEROENS underkant,
           ikke på en fast scroll-værdi. Det holder uanset hvor høj heroen
           er sat til, om annoncebjælken brydes over to linjer, og om
           brugeren er på mobil med en lavere header.
           ------------------------------------------------------------------ */
        if (this.getAttribute('data-overlay-hero') === '1') {
          this.bar = this.querySelector('.fvh-bar');
          this.findHero = () => {
            var main = document.getElementById('MainContent');
            if (!main) return null;
            var kids = Array.prototype.slice.call(main.children);
            // Første sektion med reel højde. Skjulte eller tomme sektioner
            // (app-embeds, popups) ville ellers blive valgt som "hero".
            for (var i = 0; i < kids.length; i++) {
              if (kids[i].offsetHeight > 120) return kids[i];
            }
            return kids[0] || null;
          };
          this.heroEl = this.findHero();
          this.maalHero = () => {
            if (!this.heroEl || !this.bar) return;
            var past = this.heroEl.getBoundingClientRect().bottom
                     <= this.bar.getBoundingClientRect().bottom;
            this.classList.toggle('is-past-hero', past);
          };
          this.boundHero = () => { this.heroEl = this.findHero(); this.maalHero(); };
          window.addEventListener('load', this.boundHero);
          window.addEventListener('resize', this.boundHero, { passive: true });
          this.maalHero();
        }

        this.boundMaal = () => this.maalTop();
        window.addEventListener('resize', this.boundMaal, { passive: true });
        window.addEventListener('load', this.boundMaal);
        if ('ResizeObserver' in window && this.gruppe) {
          this.ro = new ResizeObserver(this.boundMaal);
          this.ro.observe(this.gruppe);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.bound);
        if (this.boundMaal) {
          window.removeEventListener('resize', this.boundMaal);
          window.removeEventListener('load', this.boundMaal);
        }
        if (this.boundHero) {
          window.removeEventListener('resize', this.boundHero);
          window.removeEventListener('load', this.boundHero);
        }
        if (this.ro) this.ro.disconnect();
      }
      onScroll() {
        if (this.tickQueued) return;
        this.tickQueued = true;
        requestAnimationFrame(() => {
          this.tickQueued = false;
          var y = window.pageYOffset || 0;
          if (y > 8) this.classList.add('is-stuck');
          else this.classList.remove('is-stuck');
          if (this.maalHero) this.maalHero();
          this.lastY = y;
        });
      }
    }
    customElements.define('fvh-sticky', FvhSticky);
  }

  } catch(e) { console.error(e); }
})();
})();
